import { IconListCheck, IconRefresh } from "@tabler/icons-react";
import UnlockOverlay from "./UnlockOverlay";
import TestPager from "./TestPager";
import styles from "./AiInsights.module.css";
import useSwipe from "../../../../hooks/useSwipe";
import { careerPlanUnlockPrice, testResults } from "../components/data";

function InfoBlock({ label, text }) {
  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoLabel}>{label}:</div>
      <div className={styles.infoText}>{text}</div>
    </div>
  );
}

export default function ImproveOnCard({
  activeIndex,
  onSelect,
  isUnlock,
  handleTalentSubscribe,
  subscribeLoading,
  data,
  setDisclaimerModal,
}) {
  const slides = Array.isArray(data)
    ? data?.flatMap((item) => item?.testResult?.skillsAnalysis || [])
    : [];

  const items = isUnlock ? slides : testResults;
  const attempt = items[activeIndex];

  const swipeHandlers = useSwipe((dir) => {
    if (!items.length) return;
    onSelect((activeIndex + dir + items.length) % items.length);
  });

  return (
    <div className={`${styles.card} ${styles.cardImprove}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconListCheck size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>What to Improve On</div>
            <div className={styles.cardSubtitle}>
              Actionable tips based on your weaker traits
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.lockedWrap}>
          <div
            className={`${styles.lockedContent} ${isUnlock ? styles.lockedContentUnlocked : ""} ${subscribeLoading ? styles.unlockPulse : ""}`}
            {...swipeHandlers}
          >
            {data?.length > 0 && (
              <p className={styles.improveIntro}>
                Your psychometric test surfaced a few areas that, if
                strengthened, would raise both your AI score and the range of
                roles you match with. Here's where to focus first:
              </p>
            )}

            {!isUnlock && (
              <div key={activeIndex} className={styles.carouselEnter}>
                <div className={styles.testHeading}>{attempt?.skill}</div>
                <InfoBlock label="Summary" text={attempt?.summary} />
                <InfoBlock label="Weaknesses" text={attempt?.weaknesses} />
                <InfoBlock label="Strengths" text={attempt?.strengths} />
                {attempt?.improvements?.map((item) => (
                  <InfoBlock
                    key={item.title}
                    label={item.title}
                    text={item.detail}
                  />
                ))}
              </div>
            )}

            {data?.length === 0 && (
              <p className="text-base my-6 text-[#152238] text-center">
                You have not taken the psychometric test yet
              </p>
            )}
            {isUnlock && data?.length > 0 && attempt && (
              <div key={activeIndex} className={styles.carouselEnter}>
                <div className={styles.testHeading}>{attempt?.skill}</div>
                <InfoBlock label="Summary" text={attempt?.summary} />
                <InfoBlock
                  label="Weaknesses"
                  text={attempt?.weaknesses?.join(", ")}
                />
                <InfoBlock
                  label="Strengths"
                  text={attempt?.strengths?.join(", ")}
                />
                {attempt?.improvementAreas?.map((item, i) => (
                  <InfoBlock
                    key={item?.area + i}
                    label={item?.area}
                    text={item?.reason}
                  />
                ))}
              </div>
            )}

            {(isUnlock ? slides : testResults)?.length > 1 && (
              <TestPager
                items={isUnlock ? slides : testResults}
                activeIndex={activeIndex}
                onSelect={onSelect}
              />
            )}

            <div className={styles.takeTestRow}>
              <button
                onClick={() => {
                  setDisclaimerModal(true);
                }}
                className={styles.btnOutlineLink}
              >
                <IconRefresh size={14} />{" "}
                {data?.length === 0 ? "Take Test" : "Take Another Test"}
              </button>
            </div>
          </div>

          <UnlockOverlay
            unlocked={isUnlock}
            price={careerPlanUnlockPrice}
            onUnlock={handleTalentSubscribe}
            disabled={subscribeLoading}
          />
        </div>
      </div>
    </div>
  );
}
